import { getESDefaultMetricCategories } from '@src/components/notification-channel/EmailSubscriptions/utils';
import { isSearchedItem } from '../HeaderPanel/SensitivityControl/utils';
import { CURRENT_PRODUCT_MODE, PRODUCT_MODE_MAP } from '@src/utils/constants';
import { AI_ALERT_STANDARD_METRICS_MAP } from '../constants';

export const useGetAIAlertMetricsCategories = ({
  aiAlertMetricsMeta,
  searchText = '',
  categoryMap = [],
  product = CURRENT_PRODUCT_MODE,
  withOneFlowCategory = false,
}: {
  aiAlertMetricsMeta: any;
  searchText: string;
  categoryMap?: { key: string; isFlow?: boolean; metrics: any[] }[];
  product: string;
  withOneFlowCategory?: boolean;
}) => {
  const defaultCategories = getESDefaultMetricCategories()[CURRENT_PRODUCT_MODE];

  // Collect metrics by type
  const standardMetrics: any[] = [];
  const flowCategories: Record<string, any[]> = {};
  const customMetrics: any[] = [];

  aiAlertMetricsMeta.forEach((metric) => {
    const { name, isCustom, isFlow, flowCategory } = metric;
    if (!isCustom && !isFlow) {
      const isAIProduct = product === PRODUCT_MODE_MAP.AI;
      const isAIMetric = AI_ALERT_STANDARD_METRICS_MAP.AI.includes(name);
      if ((isAIProduct && isAIMetric) || (!isAIProduct && !isAIMetric)) {
        standardMetrics.push(metric);
      }
    } else if (isCustom) {
      if (isFlow && flowCategory) {
        if (!flowCategories[flowCategory]) flowCategories[flowCategory] = [];
        flowCategories[flowCategory].push(metric);
      } else {
        customMetrics.push(metric);
      }
    }
  });

  // Build ordered array
  if (standardMetrics.length) {
    categoryMap.push({
      key: defaultCategories.STANDARD_METRICS,
      metrics: standardMetrics,
      isFlow: false,
    });
  }
  if (customMetrics.length) {
    categoryMap.push({
      key: defaultCategories.CUSTOM_METRICS,
      metrics: customMetrics,
      isFlow: false,
    });
  }

  withOneFlowCategory
    ? categoryMap.push({
        key: 'Flows',
        isFlow: true,
        metrics: Object.keys(flowCategories).map((flowCat) => ({
          displayName: flowCat,
          name: flowCategories[flowCat][0].flowID,
          metrics: flowCategories[flowCat].map((m) => m.name),
        })),
      })
    : Object.keys(flowCategories)
        .sort()
        .forEach((flowCat) => {
          categoryMap.push({
            key: `Flow: ${flowCat}`,
            isFlow: true,
            metrics: flowCategories[flowCat],
          });
        });

  // Filter metrics in each category by searchText
  const filteredCategoryMap = categoryMap
    .map((category) => ({
      ...category,
      metrics: category.metrics.filter(({ displayName }) =>
        isSearchedItem(displayName, searchText),
      ),
    }))
    .filter((category) => category.metrics.length > 0);

  return { categoryMap: filteredCategoryMap };
};
